<app-modal
  heading="Add an account"
  submitLabel="Add to the list"
  [formGroup]="form"
  (submitted)="submit()"
>
  <div class="decl-dialog__form" data-testid="decl-form-ACCOUNT">
    <mat-form-field appearance="outline">
      <mat-label>Bank</mat-label>
      <input matInput formControlName="bank_name" data-testid="decl-account-bank" />
      <mat-error>Enter the bank.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Branch code</mat-label>
      <input matInput formControlName="branch_code" data-testid="decl-account-branch" />
      <mat-error>Enter the branch code.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Account number</mat-label>
      <input matInput formControlName="account_number" data-testid="decl-account-number" />
      <mat-error>Enter the account number.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Account holder</mat-label>
      <input matInput formControlName="account_holder_name" data-testid="decl-account-holder" />
      <mat-error>Enter the account holder.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="decl-dialog__wide">
      <mat-label>Does trading go through it?</mat-label>
      <mat-select formControlName="carries_trading_activity">
        @for (opt of tradingStates; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</app-modal>
